/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { powDependencies } from './dependenciesPow.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createDotPow } from '../../factoriesAny.js';
export var dotPowDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  equalScalarDependencies: equalScalarDependencies,
  matrixDependencies: matrixDependencies,
  powDependencies: powDependencies,
  typedDependencies: typedDependencies,
  createDotPow: createDotPow
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesDotPow.generated.js
// module id = 1532
// module chunks = 0